import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

interface WorkflowEmptyStateProps {
  hasFilters: boolean;
  onClearFilters?: () => void;
}

/**
 * WorkflowEmptyState - Pure presentational component for empty batch list state.
 *
 * Single Responsibility: ONLY renders empty state display.
 * Shows different messages based on whether filters are active.
 */
export const WorkflowEmptyState: React.FC<WorkflowEmptyStateProps> = ({
  hasFilters,
  onClearFilters,
}) => {
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <InboxIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        {hasFilters ? 'No batches match your filters' : 'No batches found'}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {hasFilters
          ? 'Try adjusting your filters to see more results'
          : 'Batches will appear here once they are created'}
      </Typography>
      {hasFilters && onClearFilters && (
        <Button variant="outlined" onClick={onClearFilters}>
          Clear Filters
        </Button>
      )}
    </Box>
  );
};

export default WorkflowEmptyState;
